export default __webpack_public_path__ + "static/media/Fotoentera2.ffc8e1f8.jpeg";